<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, useSlots, computed } from 'vue';

/*==================================================================*/
/*================== IMPORTS DE COMPONENTES ========================*/
/*==================================================================*/

import ResumoDaLinha from './ResumoDaLinha.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    headers: {
        type: Array,
        default: () => []
    },
    dado: {
        type: Object,
        default: () => ({})
    },
    disabled: {
        type: Boolean,
        default: false
    },
    selecao: {
        type: String,
        default: 'nenhum'
    },
    selecionado: {
        type: Boolean,
        default: false
    }
});

const emits = defineEmits([
    'update:selecionado',
]);

const slots = useSlots();

/*==================================================================*/
/*================== SLOTS DE ITEM =================================*/
/*==================================================================*/

const slotsDeItem = computed(() =>

    Object.keys(slots).filter(name => name.startsWith('linha-item.'))

);

</script>

<template>

    <div class="c-tabela__row-group">

        <ResumoDaLinha
            :headers="props.headers"
            :dado="props.dado"
            :disabled="props.disabled"
            :selecao="props.selecao"
            :selecionado="props.selecionado"
            @update:selecionado="(marcado) => emits('update:selecionado', marcado)"
        >

            <template v-if="slots['linha-botoes']" #linha-botoes="slotProps">

                <slot name="linha-botoes" v-bind="slotProps"></slot>

            </template>

            <template
                v-for="name in slotsDeItem"
                #[name]="slotProps"
            >

                <slot :name="name" v-bind="slotProps ?? {}"></slot>

            </template>

        </ResumoDaLinha>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*================== Grupo da Linha ================================*/
/*==================================================================*/

.c-tabela__row-group {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>
